const QuestContent = [
  {
    questId: 1,
    name: 'Quest Gampang',
    toolbox: ``,
    subQuest: [
      {
        id: 1,
        name: 'Mudah',
        description: 'Klik uji kode',
        content: `
          Selamat datang di <i>Quest</i> gampang!<br/>
          Klik "Uji kode" untuk menuju <i>subquest</i> selanjutnya.
        `,
        testCase: [
          { input: [], output: [] }
        ],
      },
      {
        id: 2,
        name: 'Gampang',
        description: 'Klik uji kode',
        content: `
          Sekarang di <i>subquest</i> ini, kamu diminta untuk mengeklik tombol "Uji kode".
        `,
        testCase: [
          { input: [], output: [] }
        ],
      },
      {
        id: 3,
        name: 'Easy',
        description: 'Klik uji kode',
        content: `
          Tiba juga di <i>subquest</i> terakhir! Kali ini, klik "Uji kode" untuk lanjut.
        `,
        testCase: [
          { input: [], output: [] }
        ],
      },
    ]
  },
  {
    questId: 2,
    name: 'Harta, Harta, Harta',
    disablePerStepExe: true,
    customBlocks: [
      {
        "type": "barat",
        "message0": "barat ←",
        "previousStatement": null,
        "nextStatement": null,
        "colour": 65,
        "tooltip": "",
        "helpUrl": "",
        f: () => 'alert("barat")\n'
      },
      {
        "type": "timur",
        "message0": "timur →",
        "previousStatement": null,
        "nextStatement": null,
        "colour": 65,
        "tooltip": "",
        "helpUrl": "",
        f: () => 'alert("timur")\n'
      },
      {
        "type": "utara",
        "message0": "utara ↑",
        "previousStatement": null,
        "nextStatement": null,
        "colour": 65,
        "tooltip": "",
        "helpUrl": "",
        f: () => 'alert("utara")\n'
      },
      {
        "type": "selatan",
        "message0": "selatan ↓",
        "previousStatement": null,
        "nextStatement": null,
        "colour": 65,
        "tooltip": "Bergerak ke selatan.",
        "helpUrl": "",
        f: () => 'alert("selatan")\n'
      }
    ],
    customGrader: (result, rawTestCase) => {
      let x = 0, y = 0, gemCount = 0
      let finish = false
      const testCase = rawTestCase[0].output
      let diamond = testCase.diamond.slice()
      const gemMax = diamond.length

      for (let item of result[0]) {
        if (item === 'barat') x--
        else if (item === 'timur') x++
        else if (item === 'utara') y++
        else y--

        const pos = `${x} ${y}`

        if (pos === testCase.finish) {
           finish = true
          break
        }

        const index = diamond.indexOf(pos)
        if (index !== -1) {
          diamond.splice(index, 1)
          gemCount++
        }
      }
      return {score: finish ? 50 + 50 * gemCount / gemMax : 0, stats: {"Berlian didapatkan": `${gemCount}/${gemMax}`, "Tiba di titik finis?": finish ? 'Ya' : 'Tidak'}}
    },
    customConsole: (result, currentTestCase) => {
      let matrix = []
      let display = ''
      const testCase = currentTestCase[0].output
      const finish = testCase.finish.split(" ").map(el => parseInt(el))
      const offset = testCase.offset ? testCase.offset.split(" ").map(el => parseInt(el)) : [0,0]

      for(let i = 0; i <= 9; i++) {
        matrix[i] = []
        for(let j = 0; j <= 11; j++) {
          matrix[i][j] = 'blank-tile'
        }
      }

      for (let i in testCase.diamond) {
        const diamond = testCase.diamond[i].split(" ").map(el => parseInt(el))
        matrix[diamond[1]+offset[1]][diamond[0]+offset[0]] = 'diamond-tile'
      }

      matrix[finish[1]+offset[1]][finish[0]+offset[0]] = 'finish-tile'

      let x = offset[0], y = offset[1]
      matrix[y][x] = 'current-tile'
      for (let item of result) {
        if (item === 'barat') {
          if (x >= 0 && x <= 11 && y >= 0 && y <= 9) matrix[y][x] = 'left-tile'
          x--
        }
        else if (item === 'timur') {
          if (x >= 0 && x <= 11 && y >= 0 && y <= 9) matrix[y][x] = 'right-tile'
          x++
        }
        else if (item === 'utara') {
          if (x >= 0 && x <= 11 && y >= 0 && y <= 9) matrix[y][x] = 'up-tile'
          y++
        }
        else {
          if (x >= 0 && x <= 11 && y >= 0 && y <= 9) matrix[y][x] = 'down-tile'
          y--
        }
        if (x >= 0 && x <= 11 && y >= 0 && y <= 9) matrix[y][x] = 'current-tile'
        if ((x + ' ' + y) === testCase.finish) break
      }

      for (let i = 9; i >= 0; i--) {
        display += `
          <div style="height: 24px; display: flex; align-items: center">
          <small style="display: inline-block; width: 24px; text-align: center"><b>${i}</b></small>
        `
        for (let j = 0; j <= 11; j++) {
          display += `<img src="/images/${matrix[i][j]}.png" alt="direction">`
        }
        display += `</div>`
      }
      display += '<span style="margin-left: 24px"></span>'
      for (let j = 0; j <= 11; j++) {
        display += `<small style="display: inline-block; text-align: center; width: 24px"><b>${j}</b></small>`
      }

      return display
    },
    toolbox: `
      <xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
        <category name="Arah" colour="#9fa55b">
          <label text="Arah pergerakan" web-class="toolbox-label"/>
          <block type="barat"/>
          <block type="timur"/>
          <block type="utara"/>
          <block type="selatan"/>
        </category>
        <category name="Pengulangan" colour="#5ba55b">
          <label text="Blok pengulangan" web-class="toolbox-label"/>
          <block type="controls_repeat_ext">
            <value name="TIMES">
              <shadow type="math_number">
                <field name="NUM">10</field>
              </shadow>
            </value>
          </block>
        </category>
      </xml>
    `,
    subQuest: [
      {
        id: 1,
        name: 'Lead the Way 1',
        description: 'Tuntunlah Tuan Chi menuju titik finis',
        content: `
          <div class="flex align-items-center">
            <div class="flex-no-shrink">
              <img class="image-fit" src="/images/directional-arrow.jpg">
            </div>
            <div class="ml-2">
              Perkenalkan kategori khusus <i>quest</i> ini, yaitu kategori <b>Arah</b>.<br><br>
              
              Gunakanlah blok-blok di kategori ini untuk menuntun Tuan Chi menuju titik finis, sekaligus mengoleksi
              berlian yang ada di jalan. Setiap blok akan menggerakan Tuan Chi satu petak ke arah yang dituju.<br><br>
            </div>
          </div>
          <div class="text-center">
            <img src="/images/grid-example.jpg">
          </div>
          Huruf "<b>S</b>" menandai titik mulai Tuan Chi, gambar <b>berlian</b> menandakan harta yang dapat dikoleksi,
          dan <b>bendera</b> menandakan titik finis Tuan Chi. Gambar di bawah merupakan contoh blok yang disusun
          untuk mendapatkan berlian dan mencapai titik finis (garis oranye menandakan jalan yang dilalui).
          <div class="text-center">
            <img src="/images/grid-example-2.jpg">
          </div>
          
          <div class="my-2">
            Untuk <i>quest</i> ini, <b>kamu tidak harus mengoleksi seluruh berlian yang ada</b>, tetapi itu dapat berpengaruh
            ke skor yang kamu dapatkan. Kamu akan mendapatkan skor dasar <b>50% untuk mencapai titik finis</b>,
            dan 50% sisanya didapatkan dari <b>persentase total berlian yang didapatkan</b>.<br><br>
            
            Perhatikan bahwa apabila kamu tidak mencapai titik
            finis, maka <b class="red">kamu tidak dianggap mendapatkan berlian yang ada di jalan</b>.
          </div>
          Di bawah adalah peta keberadaan Tuan Chi sekarang. Tuntunlah Tuan Chi untuk mencapai titik finis dengan
          berlian sebanyak-banyaknya! <b>Kamu memiliki batas 20 blok yang dapat digunakan di kanvas sehingga gunakanlah
          blok seefisien mungkin.</b>
          <div class="text-center mt-2">
            <img class="image-fit"  src="/images/harta1.png">
          </div>
          <br>
          <h2>Tips</h2>
          Gunakan blok <b>repeat</b> untuk mengulang gerakan yang sama.
        `,
        testCase: [
          { input: [], output: { diamond: ["9 0", "4 4", "2 4", "3 7", "8 9"], finish: "11 9" } }
        ],
        maxBlocks: 20,
      },
      {
        id: 2,
        name: 'Lead the Way 2',
        description: 'Tuntunlah Tuan Chi menuju titik finis',
        content: `
          Kamu berhasil melewati <i>subquest</i> pertama! Sekarang saatnya kamu bantu Tuan Chi mengembara di kota baru ini dengan <b>15 blok</b>.<br>
          <div class="text-center mt-2">
            <img class="image-fit"  src="/images/harta2.png">
          </div><br>
          <h2>Tips</h2>
          Ingatlah beberapa fakta ini untuk (mungkin) membantumu mendapatkan seluruh berlian di <i>subquest</i> ini dan berikutnya.
          <ul>
            <li>Petak yang tersedia tak hanya terbatas pada yang tergambar pada peta -- kamu dapat pergi "keluar" dari kota ini.</li>
            <li>Apabila Tuan Chi telah menyentuh petak finis, ia akan selalu diam di situ meskipun ada perintah lebih lanjut.</li>
            <li>Manfaatkan blok <b>repeat</b> sebaik mungkin. Soal tipe ini hanya membatasi jumlah blok yang digunakan, sehingga kamu dapat memaksimalkan jumlah langkah dengan blok yang sedikit.</li>
          </ul><br>
          <p>Perlu diperhatikan bahwa blok <b>repeat</b> <b>memakan kuota 2 blok dengan sendirinya</b>, sehingga jangan gunakan blok <b>repeat</b>
          ketika hanya ingin berpindah sejauh dua petak.</p><br>
          <i>Good luck!</i>
        `,
        testCase: [
          { input: [], output: { diamond: ["3 2", "4 3", "5 4", "6 5", "7 6", "8 7", "6 2", "8 4", "5 7", "3 5"], finish: "11 9" } }
        ],
        maxBlocks: 15,
      },
      {
        id: 3,
        name: 'Lead the Way 3',
        description: 'Tuntunlah Tuan Chi menuju titik finis',
        content: `
          Sekarang Tuan Chi telah tiba di kota terakhir!
          <br>Bantulah ia untuk mendapatkan berlian dan menuju titik finis dengan <b>22 blok</b> saja.<br><br>
          
          Ingat bahwa Tuan Chi <b>tidak dapat bergerak kembali setelah mencapai titik finis.</b>
          
          <div class="text-center mt-2">
            <img class="image-fit"  src="/images/harta3.png">
          </div>
        `,
        testCase: [
          { input: [], output: { diamond: ["-5 1", "-4 3", "-3 0", "-2 2", "1 -3", "2 -1", "3 -4", "4 -2"], finish: "-1 -1", offset: "6 5" } }
        ],
        maxBlocks: 22,
      },
    ]
  },
  {
    questId: 3,
    name: 'Lorem ipsum lagi',
    toolbox: ``,
    subQuest: [
      {
        id: 1,
        name: 'Dolor',
        description: 'Klik uji kode',
        content: `
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque molestie dui viverra lacus mattis tristique. Aenean tristique sodales quam, ut viverra mauris sollicitudin sed. Mauris pharetra urna sed rhoncus vulputate. Fusce tempor ante ac tempus volutpat. Cras iaculis porttitor sapien vitae tincidunt. In feugiat odio velit, vel facilisis nibh sagittis ac. Nunc ut auctor sapien, non fringilla felis. Pellentesque vestibulum lectus vitae nisi condimentum bibendum. Curabitur in porttitor mauris, at scelerisque metus. Sed magna ex, ultricies a gravida sed, congue et turpis.<br><br>

          Integer ut venenatis arcu, in pretium sem. Integer suscipit lorem eu tortor iaculis, quis tristique massa feugiat. Mauris faucibus rutrum purus, ultrices lobortis odio consequat eget. Cras finibus velit bibendum mauris venenatis, at faucibus arcu efficitur. Proin ac odio neque. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Aenean eget dictum lectus. Praesent sit amet enim nec ante dignissim vulputate. Quisque feugiat tellus egestas, egestas est quis, placerat ex. Maecenas rutrum gravida blandit. Suspendisse ac mattis arcu. Aliquam vitae lectus justo. Aenean quis aliquet neque. Donec at metus eget purus commodo tristique a vel neque.\`,

        `,
        testCase: [
          { input: [], output: [] }
        ],
      },
      {
        id: 2,
        name: 'Sit',
        description: 'Klik uji kode',
        content: `
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque molestie dui viverra lacus mattis tristique. Aenean tristique sodales quam, ut viverra mauris sollicitudin sed. Mauris pharetra urna sed rhoncus vulputate. Fusce tempor ante ac tempus volutpat. Cras iaculis porttitor sapien vitae tincidunt. In feugiat odio velit, vel facilisis nibh sagittis ac. Nunc ut auctor sapien, non fringilla felis. Pellentesque vestibulum lectus vitae nisi condimentum bibendum. Curabitur in porttitor mauris, at scelerisque metus. Sed magna ex, ultricies a gravida sed, congue et turpis.<br><br>

          Integer ut venenatis arcu, in pretium sem. Integer suscipit lorem eu tortor iaculis, quis tristique massa feugiat. Mauris faucibus rutrum purus, ultrices lobortis odio consequat eget. Cras finibus velit bibendum mauris venenatis, at faucibus arcu efficitur. Proin ac odio neque. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Aenean eget dictum lectus. Praesent sit amet enim nec ante dignissim vulputate. Quisque feugiat tellus egestas, egestas est quis, placerat ex. Maecenas rutrum gravida blandit. Suspendisse ac mattis arcu. Aliquam vitae lectus justo. Aenean quis aliquet neque. Donec at metus eget purus commodo tristique a vel neque.\`,

        `,
        testCase: [
          { input: [], output: [] }
        ],
      },
      {
        id: 3,
        name: 'Amet',
        description: 'Klik uji kode',
        content: `
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque molestie dui viverra lacus mattis tristique. Aenean tristique sodales quam, ut viverra mauris sollicitudin sed. Mauris pharetra urna sed rhoncus vulputate. Fusce tempor ante ac tempus volutpat. Cras iaculis porttitor sapien vitae tincidunt. In feugiat odio velit, vel facilisis nibh sagittis ac. Nunc ut auctor sapien, non fringilla felis. Pellentesque vestibulum lectus vitae nisi condimentum bibendum. Curabitur in porttitor mauris, at scelerisque metus. Sed magna ex, ultricies a gravida sed, congue et turpis.<br><br>

          Integer ut venenatis arcu, in pretium sem. Integer suscipit lorem eu tortor iaculis, quis tristique massa feugiat. Mauris faucibus rutrum purus, ultrices lobortis odio consequat eget. Cras finibus velit bibendum mauris venenatis, at faucibus arcu efficitur. Proin ac odio neque. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Aenean eget dictum lectus. Praesent sit amet enim nec ante dignissim vulputate. Quisque feugiat tellus egestas, egestas est quis, placerat ex. Maecenas rutrum gravida blandit. Suspendisse ac mattis arcu. Aliquam vitae lectus justo. Aenean quis aliquet neque. Donec at metus eget purus commodo tristique a vel neque.\`,

        `,
        testCase: [
          { input: [], output: [] }
        ],
      },
    ]
  },
]

export default QuestContent
